import { createRoot } from "react-dom/client";
import { AuthConfig } from "./modules/auth/types";
import App from "./modules/_app/App";
import config from "./modules/_app/config";
import { stripSensitiveParams } from "./modules/auth/lib/sensitiveParams";

// Strip sensitive auth params from the URL before analytics loads below.
stripSensitiveParams();

declare global {
  interface Window {
    Cypress: any;
    HubSpotConversations: any;
    hsConversationsOnReady: any;
    authConfig: AuthConfig;
  }
}

if (config?.configGoogleTagManager?.gtmId) {
  import("./modules/_app/lib/googletagmanager");
}

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<App />);
}
